// This file should contain ALL keys used by *any* environment
// the values in this file should be that of the DEVELOPMENT environment
// other named environment files (i.e. environment.smoke.ts) should include ONLY overrides to values as necessary
// Common configs point to nightly environment

export const commonConfig = {
    appId: 'savvaslearning',
    appName: 'multi-stage-report-webapp',
    authContextId: '6065',
    metricMeasureCompany: 'MetaMetrics, Inc.',

    production: false,
    authGatewayUrl: 'https://rr-auth-gateway.nightly.savvasrealizedev.com/sapi',
    rbsConfig: {
        scope: 'rbs',
        clientId: '',
        grant_type: 'custom_castgc',
    },
    ssoUrl: 'https://nightly-sso.rumba.pk12ls.com/sso',
    ssoLoginQueryParams: {
        k12int: true,
    },
    errorRoute: 'error',
    authCallbackRoute: 'auth-callback',
    backendForFrontend: {
        url: 'https://dev.multi-stage-report-bff.savvasrealizedev.com',
        apiPath: '/graphql',
    },
    realizeUrl: 'https://nightly-www.savvasrealizedev.com',
    assessmentsWebappConfig: {
        // remoteEntry: 'http://localhost:4802/assessments-webapp/assessmentsRemoteEntry.js',   // <- for local
        remoteEntry: 'https://nightly-www.savvasrealizedev.com/assessments-webapp/assessmentsRemoteEntry.js',
        remoteName: 'AssessmentsWebapp',
        exposedModule: './AssessmentQuestionPreviewModule',
    },
    standardViewerConfig: {
        remoteEntry:
            'https://skills-standards-webapp-stage.savvasrealizedev.com/skills-standards-tools/skillsstandardswebapp.js',
        remoteName: 'skillsstandardswebapp',
        exposedModule: './StandardsModule',
    },
    searchViewerConfig: {
        remoteEntry: 'https://nightly-www.savvasrealizedev.com/search/viewer/rswRemoteEntry.js',
        remoteName: 'resourceSearchWeb',
        exposedModule: './view-resources',
        moduleName: 'ViewResourcesModule',
    },
    resourceSearchConfig: {
        remoteEntry: 'https://nightly-www.savvasrealizedev.com/search/viewer/rswRemoteEntry.js',
        remoteName: 'resourceSearchWeb',
        exposedModule: './rsw-search',
        moduleName: 'RswRootModule',
    },
};
